import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const CONFIG = {
  light: { Icon: Moon,    label: "Light mode · click for Dark",   testId: "theme-toggle-moon" },
  dark:  { Icon: Sun,     label: "Dark mode · click for Auto",    testId: "theme-toggle-sun" },
  auto:  { Icon: Monitor, label: "Auto (follows system) · click for Light", testId: "theme-toggle-monitor" },
};

export default function ThemeToggle() {
  const { theme, resolved, cycle } = useTheme();
  const { Icon, label, testId } = CONFIG[theme] || CONFIG.auto;
  return (
    <button
      type="button"
      onClick={cycle}
      title={label}
      aria-label={label}
      data-testid="theme-toggle"
      data-theme={theme}
      data-resolved={resolved}
      className="fixed top-3 right-3 z-50 h-9 min-w-9 px-2 grid grid-flow-col items-center gap-1.5 rounded-full border border-zinc-200 bg-white text-zinc-700 shadow-sm hover:bg-zinc-50 hover:text-zinc-950 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-200 dark:hover:bg-zinc-800 dark:hover:text-white transition-colors duration-200"
    >
      <Icon className="h-4 w-4" strokeWidth={2.2} data-testid={testId} />
      {theme === "auto" && (
        <span className="text-[10px] uppercase tracking-[0.1em] pr-1" data-testid="theme-toggle-auto-badge">Auto</span>
      )}
    </button>
  );
}
